import dynamic from 'next/dynamic';
import { useGlobal } from '@/utils/useGlobal';
import PCLayout from '@/components/XStreamNew';
import H5Layout from '@/componentsH5/xstream';
import { readySites } from '@/constants';
import PageLayout from '@/components/PageLayout';
import SEOlinksA from '@/components/SEOlinksA';

export default function Xstream({ SEO, lang }: any) {
    const { isMobile, useEffect, useRouter } = useGlobal();
    const router = useRouter();
    const LayoutCom = isMobile ? H5Layout : PCLayout;
    const GtmPageLoad = dynamic(() => import('@/components/GtmPageLoad'), { ssr: false });
    useEffect(() => {
        if (!readySites.includes(router?.locale)) {
            router?.replace(`${router?.locale}/404`);
        }
    }, [router?.locale]);

    return (
        <PageLayout theme="black">
            <SEO title={lang.seo_title || 'x-stream'} description={lang.seo_desc || 'x-stream'} />
            <SEOlinksA locale={router.locale} list={['us', 'za', 'uk', 'ca', 'au', 'sa', 'kr', 'mx', 'ph']} pathname={'x-stream'} />
            <GtmPageLoad />
            <h1 className="visuallyhidden">EcoFlow x-stream</h1>
            <LayoutCom />
        </PageLayout>
    );
}
